/* MailBakes header - announcement rotation, mobile drawer, preview-bar guard */
(function () {
  'use strict';

  var ann = document.querySelector('[data-mb-ann]');
  if (ann) {
    var slides = ann.querySelectorAll('.mb-ann__slide');
    if (slides.length > 1) {
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove('is-on');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-on');
      }, 5000);
    }
  }

  /* ---- Shopify's theme-preview strip is pinned to the bottom of the window
     and sits on top of our sticky action bar, so clicks on Continue /
     Add to basket land on the strip instead of the button. Measuring the
     iframe is useless (it reports full-window height), so probe instead:
     nudge the bar up until a hit-test at the button's centre actually
     returns the button. Self-limiting, and a no-op once published. ---- */
  function liftStickyBars() {
    var bar = document.querySelector('.mb-bar');
    var btn = document.getElementById('mb-next');
    if (!bar || !btn) return;

    bar.style.bottom = '';
    var lift = 0;
    for (var i = 0; i < 10; i++) {
      var r = btn.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) break;
      var hit = document.elementFromPoint(r.left + r.width / 2, r.top + r.height / 2);
      if (hit === btn || (hit && btn.contains(hit))) break;
      lift += 16;
      if (lift > 144) { lift = 0; break; }
      bar.style.bottom = lift + 'px';
    }
    bar.style.bottom = lift ? lift + 'px' : '';

    var err = document.querySelector('.mb-err');
    if (err) err.style.bottom = lift ? (lift + 86) + 'px' : '';
    document.documentElement.style.setProperty('--mb-previewbar', lift + 'px');
  }

  var tries = 0;
  var poll = setInterval(function () {
    liftStickyBars();
    if (++tries > 12) clearInterval(poll);
  }, 500);
  window.addEventListener('resize', liftStickyBars);

  /* ---- mobile drawer ---- */
  var drawer = document.querySelector('[data-mb-drawer]');
  var scrim = document.querySelector('[data-mb-scrim]');
  var body = document.querySelector('[data-mb-drawer-body]');
  var title = document.querySelector('[data-mb-drawer-title]');
  var backBtn = document.querySelector('[data-mb-drawer-back]');
  var openBtn = document.querySelector('[data-mb-drawer-open]');
  var closeBtn = document.querySelector('[data-mb-drawer-close]');
  var json = document.querySelector('[data-mb-menu-json]');
  if (!drawer || !body || !json) return;

  var MENU = [];
  try { MENU = JSON.parse(json.textContent); } catch (e) { MENU = []; }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderRoot() {
    title.textContent = 'Menu';
    backBtn.hidden = true;
    body.innerHTML = MENU.map(function (t, idx) {
      /* An item with no sub-groups (Create Your Own, Reminders) is a plain
         link - tapping it goes straight to the page instead of opening an
         empty "Shop all" step. */
      if (!t.g || !t.g.length) {
        return '<a class="mb-drow" href="' + esc(t.u) + '">' + esc(t.t) + '</a>';
      }
      return '<button class="mb-drow" type="button" data-mb-top="' + idx + '">' +
        esc(t.t) + '<span class="mb-drow__ar">&rsaquo;</span></button>';
    }).join('');
  }

  /* "Shop all X" goes straight to a browsable collection where one exists,
     rather than the occasion landing page. */
  var SHOP_ALL = {
    '/pages/birthday': '/collections/birthday',
    '/pages/anniversary': '/collections/anniversary-cake-cards'
  };

  function renderTop(idx) {
    var t = MENU[idx];
    if (!t) return;
    title.textContent = t.t;
    backBtn.hidden = false;
    var saUrl = SHOP_ALL[String(t.u).split('?')[0]] || t.u;
    var html = '<a class="mb-drow" href="' + esc(saUrl) + '">Shop all ' + esc(t.t) +
      '<span class="mb-drow__ar">&rsaquo;</span></a>';
    html += t.g.map(function (g) {
      var items = (g.i || []).map(function (x) {
        return '<a class="mb-drow mb-drow--sub" href="' + esc(x.u) + '">' + esc(x.t) +
          (x.n != null ? '<span class="mb-drow__n">' + esc(x.n) + '</span>' : '') + '</a>';
      }).join('');
      if (!items) {
        items = '<a class="mb-drow mb-drow--sub" href="' + esc(g.u) + '">Shop all</a>';
      }
      return '<div class="mb-dsec">' + esc(g.h) + '</div>' + items;
    }).join('');
    body.innerHTML = html;
  }

  function open() {
    renderRoot();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    scrim.hidden = false;
    requestAnimationFrame(function () { scrim.classList.add('is-open'); });
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    scrim.classList.remove('is-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    setTimeout(function () { if (!scrim.classList.contains('is-open')) scrim.hidden = true; }, 300);
  }

  if (openBtn) openBtn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  scrim.addEventListener('click', close);
  backBtn.addEventListener('click', renderRoot);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
  body.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mb-top]');
    if (b) renderTop(parseInt(b.getAttribute('data-mb-top'), 10));
  });

  document.addEventListener('mb:cart:updated', function (e) {
    var n = e.detail && e.detail.item_count;
    if (n == null) return;
    document.querySelectorAll('[data-mb-cart-count]').forEach(function (el) { el.textContent = n; });
  });
})();
